import { render } from "./up.vue?vue&type=template&id=bc6b88f8"
import script from "./up.vue?vue&type=script&lang=js"
export * from "./up.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__